import BaseApiClient from '../BaseApiClient';
import { SAVINGS_API_VERSION_HEADERS } from '../savings-reference-resource';
import type {
  SavingsCumChargeDaily,
  SavingsCumChargeDateRange,
  SavingsCumChargeSummaryRow
} from '@/interfaces/SavingsCashUnderManagementCharge.interface';

/**
 * Cash-under-management billing (FLT-2083): the all-customer charge
 * summary, one customer's daily charges, and the fire-and-forget request
 * for the Savings platform to recalculate a customer's latest charge.
 */
export class ApiSavingsBilling extends BaseApiClient {
  async summary(
    range: SavingsCumChargeDateRange
  ): Promise<SavingsCumChargeSummaryRow[]> {
    const res = await this.client.get<{ data: SavingsCumChargeSummaryRow[] }>(
      '/savings-cash-under-management-charges',
      { headers: SAVINGS_API_VERSION_HEADERS, params: range }
    );
    return res.data.data;
  }

  async daily(
    customerId: number,
    range: SavingsCumChargeDateRange
  ): Promise<SavingsCumChargeDaily> {
    const res = await this.client.get<{ data: SavingsCumChargeDaily }>(
      `/savings-customers/${customerId}/cash-under-management-charges`,
      { headers: SAVINGS_API_VERSION_HEADERS, params: range }
    );
    return res.data.data;
  }

  async recalculate(customerId: number): Promise<{ message: string }> {
    const res = await this.client.post<{ message: string }>(
      `/savings-customers/${customerId}/cash-under-management-charges/recalculations`,
      {},
      { headers: SAVINGS_API_VERSION_HEADERS }
    );
    return res.data;
  }
}

export * from './query-keys';
export * from './use-savings-billing-queries';
export * from './use-savings-billing-mutations';
